import {MakerDataState} from "../store/makerDataSlice";
import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import {UploadStatus} from "../Interfaces/SlideData";
import {MUSIC_TYPE_LOCAL, MUSIC_TYPE_USER} from "../Interfaces/MusicData";

/**
 * Подготавливаем данные для сохранения проекта или макета
 */
export function prepareData(makerData: MakerDataState, dispatch: Dispatch<AnyAction>)
{
    const activeThemeIndex = makerData.themes.findIndex(s => s.isActive === true);
    let activeTheme = makerData.currentTheme; // ЭТО НЕ ТА ТЕМА, которую выбрали, а та, которая сейчас показывается в Popup'е выбора темы
    if (activeThemeIndex >= 0) {
        activeTheme = makerData.themes[activeThemeIndex]; // а это как раз та тема, на которую нажали "Выбрать эту тему"
    }

    let partnerId = '';
    if (makerData.vkLaunchParams?.vk_app_id) {
        partnerId = 'vk' + (makerData?.vkClientVersion ? '-' + makerData?.vkClientVersion : '');
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('partnerId')) {
        partnerId = String(urlParams.get('partnerId'));
    }

    return {
        partnerId: partnerId,
        vkLaunchParams: makerData.vkLaunchParams,
        userId: makerData.userId,
        previewId: makerData.previewId,
        theme: activeTheme.themeId,
        slides: makerData.slides.filter((item) => {
            return item.status == UploadStatus.ready;
        }).map((item) => {
            if (item.type == 'text') {
                const obj:any = {
                    type: item.type,
                    text: item.text,
                    thumbnail_url: item.thumbnail_url,
                    src: item.src?.split('?')[0],
                    medium_url: item.medium_url?.split('?')[0],
                    createdAt: item.createdAt
                };
                if (item.pathInfoFilename) {
                    obj.pathInfoFilename = item.pathInfoFilename;
                } else {
                    obj.pathInfoFilename = '';
                }
                return obj;
            }
            if (item.type == 'photo') {
                const obj:any = {
                    type: item.type,
                    src: item.src?.split('?')[0],
                    createdAt: item.createdAt
                }
                if (item.thumbnail_url) {
                    obj.thumbnail_url = item.thumbnail_url.split('?')[0];
                }
                if (item.medium_url) {
                    obj.medium_url = item.medium_url.split('?')[0];
                }
                if (item.pathInfoFilename) {
                    obj.pathInfoFilename = item.pathInfoFilename;
                } else {
                    obj.pathInfoFilename = '';
                }
                return obj;
            }
        }).filter((item) => {
            return item != null;
        }),
        /**/
        thumbs: makerData.slides.map((item) => {
            if (item.type == 'photo') {
                return item.medium_url?.split('?')[0];
            }
        }).filter((item) => {
            return item != null;
        }),
        /**/
        sound: makerData.currentMusic?.type == MUSIC_TYPE_LOCAL ?
            'local:' + makerData.currentMusic.id + '.mp3' :
            makerData.currentMusic?.url,
        /**/
        email: makerData.email,
        totalPrice: makerData.fullVideoPrice,
        type: 'slru',
        i18nLang: 'ru',
        receiveCompleteNotification: 1,
        videoRes: 1080,
        isFree: 0,
        scenes: makerData.scenes,
        freeTimeMin: makerData.fullVideoMakeTime,
        promoCode: makerData.promoCode,
        promoCodeDiscount: makerData.promoCodeDiscount,
        tmpProjectId: makerData.tmpProjectId,
        jStorage: JSON.stringify(
            {
                'userMusic': makerData.music.filter(musicItemData => {
                    return musicItemData.type == MUSIC_TYPE_USER
                }),
                'numCardsBeforePay': makerData.cardsBeforePay.length
            }
        ),
        info: makerData.info,
        infoC: makerData.infoC,
        cardSlug: makerData.cardSlug,
        slSession: document.cookie.split('; ').find((row) => row.startsWith('sl-session='))?.split('=')[1],
        ymClientId: makerData.ymClientId
    }
}